export const DOG_DESKTOP_QUERY =
    "(min-width: 1024px) and (orientation: landscape), (min-width: 1280px)";

export const DOG_HEADER_VARS =
    "dog-desktop:[--container-page:100rem] dog-desktop:[--dog-navigation-height:var(--spacing-header)] dog-desktop:[--dog-context-height:60px] dog-desktop:[--dog-header-height:calc(var(--dog-navigation-height)+var(--dog-context-height))]";

export const DOG_DESKTOP_GRID = `${DOG_HEADER_VARS} dog-desktop:page-container dog-desktop:page-grid dog-desktop:items-start`;

export const DOG_CONTENT_COLUMN =
    "dog-desktop:col-start-8 dog-desktop:col-span-5";
const DOG_CONTENT_COLUMNS_BEFORE = 7;
const PAGE_GRID_COLUMNS = 12;
const DOG_PAGE_MAX = "100rem";

const DOG_PAGE_GUTTER = `max(0px, (100% - ${DOG_PAGE_MAX}) / 2) + var(--spacing-grid-margin)`;

const PAGE_GRID_TRACK = `(min(100%, ${DOG_PAGE_MAX}) - 2 * var(--spacing-grid-margin) + var(--spacing-grid-gap)) / ${PAGE_GRID_COLUMNS}`;

export const DOG_CONTENT_COLUMN_LEFT = `calc(${DOG_PAGE_GUTTER} + ${DOG_CONTENT_COLUMNS_BEFORE} * ${PAGE_GRID_TRACK})`;

export const DOG_CONTENT_COLUMN_RIGHT = `calc(${DOG_PAGE_GUTTER})`;
